import { z } from 'zod';
import { reportCubeCatalog } from './catalog.js';
import { findMemberMeta } from './utils.js';
export const reportScheduleRuntimeFilterSchema = z.object({
    member: z.string(),
    operator: z.string(),
    values: z.array(z.string()).min(1),
});
const needsValue = (operator) => reportCubeCatalog.filterOperatorMeta[operator]?.valueShape !== 'none';
// "Ask before running" filters are answered by a person each time the report runs. A scheduled
// email has nobody to ask, so it carries its own answers (see applyRuntimeFilterValues).
export const getPromptedFilters = (query) => (query.filters ?? []).filter((filter) => filter.isRuntimeParameter === true && needsValue(filter.operator));
export const describePromptedFilters = (filters) => filters
    .map(({ member }) => {
    const cube = reportCubeCatalog.cubes[member.split('.')[0] ?? ''];
    return cube ? (findMemberMeta(cube, member)?.label ?? member) : member;
})
    .join(', ');
export const applyRuntimeFilterValues = (query, runtimeFilterValues) => {
    const unused = [...(runtimeFilterValues ?? [])];
    const missing = [];
    const filters = (query.filters ?? []).map((filter) => {
        if (!(filter.isRuntimeParameter === true && needsValue(filter.operator)))
            return filter;
        const index = unused.findIndex((stored) => stored.member === filter.member && stored.operator === filter.operator);
        if (index === -1) {
            missing.push(filter);
            return filter;
        }
        const [stored] = unused.splice(index, 1);
        return { ...filter, values: stored.values };
    });
    return { missing, query: { ...query, filters } };
};
